// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const InsertImageIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "InsertImage",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.51 4h-19C4.02 4 2.01 6.01 2 8.5v15c0 2.48 2.01 4.49 4.49 4.5h19c2.48 0 4.49-2 4.51-4.47V8.5c0-2.48-2.01-4.49-4.49-4.5M27 23.53c0 .83-.67 1.5-1.5 1.5h-19c-.83 0-1.5-.67-1.5-1.5V8.5c0-.82.67-1.49 1.49-1.5H25.5c.83 0 1.5.67 1.5 1.5zm-2.94-11.42a1.505 1.505 0 0 0-1.66.4s-6 7-6 7c-.09.11-.23.17-.38.17-.08 0-.16-.02-.23-.06s-3-3.3-3-3.3c-.25-.2-.57-.32-.92-.32-.08 0-.15 0-.23.02-.41.05-.77.26-1 .57s-3.38 4-3.38 4c-.18.25-.29.56-.29.89 0 .83.67 1.5 1.5 1.5h15.01c.83 0 1.5-.67 1.5-1.5v-8c0-.63-.38-1.16-.92-1.39h-.01Zm-13.07-1.1c0 1.1-.9 2-2 2s-2-.9-2-2 .89-2 2-2 2 .89 2 2"
    })
  });
};